<template>
  <div>
    <div class="_footer" v-if="$store.state.screenWidth > 960">
      <div class="_center">
        <div class="_top">
          <div class="_left">
            <ul class="_left_list">
              <li class="_item _title" @click="toNo1">
                <a href="javascript:;">关于彼盟</a>
              </li>
              <li class="_item" @click="toNo1">
                <a href="javascript:;">公司简介</a>
              </li>
              <li class="_item" @click="toNo2">
                <a href="javascript:;">企业文化</a>
              </li>
              <li class="_item" @click="toNo3">
                <a href="javascript:;">发展历程</a>
              </li>
              <li class="_item" @click="toNo4">
                <a href="javascript:;">组织架构</a>
              </li>
              <li class="_item" @click="toNo5">
                <a href="javascript:;">荣誉展示</a>
              </li>
            </ul>
            <ul class="_left_list">
              <li class="_item _title">
                <a href="#/product/lvp">产品中心</a>
              </li>
              <li class="_item">
                <a href="#/product/lvp">HBIM LVP</a>
              </li>
              <li class="_item">
                <a href="#/product/opm">HBIM OPM</a>
              </li>
              <!-- <li class="_item">
              <a href="#/news/report">专题报道</a>
            </li> -->
            </ul>
            <ul class="_left_list">
              <li class="_item _title">
                <a href="#/project">项目案例</a>
              </li>
            </ul>
            <ul class="_left_list">
              <li class="_item _title">
                <a href="#/news">新闻中心</a>
              </li>
              <li class="_item">
                <a href="#/news">企业资讯</a>
              </li>
              <!-- <li class="_item">
              <a href="#/news/industry">行业动态</a>
            </li>
            <li class="_item">
              <a href="#/news/report">专题报道</a>
            </li> -->
            </ul>
            <ul class="_left_list">
              <li class="_item _title">
                <a href="#/contact">联系我们</a>
              </li>
              <li class="_item">
                <a href="#/contact">战略合作</a>
              </li>
              <li class="_item">
                <a href="#/contact/relation">联系我们</a>
              </li>
              <li class="_item">
                <a href="#/contact/join_us">诚聘英才</a>
              </li>
            </ul>
          </div>
          <div class="_right">
            <div class="_info">
              <p>
                <i class="iconfont icon-daohangdizhi" style="margin-right: 10px"></i>
                浙江省杭州市滨江区长河街道共鸣巷299号A楼906室
              </p>
              <p><i class="iconfont icon-24gf-telephone" style="margin-right: 10px"></i>400-0098-709</p>
              <p><i class="iconfont icon-youxiang" style="margin-right: 10px"></i>bimeng0913@163.com</p>
            </div>
            <div class="_wechat">
              <div class="_img"></div>
              <p>微信公众号</p>
            </div>
            <div class="_wechat">
              <div class="_img_video"></div>
              <p>微信视频号</p>
            </div>
          </div>
        </div>
        <div class="_line"></div>
        <div class="_btm">
          <span style="margin-right: 40px">
            Copyright &copy; 2015-2025 杭州彼盟建筑科技管理有限公司 All Rights Reserved
          </span>
          <img src="../../assets/images/icon_zgw.png" alt="" />
          <span>浙公网安备 33010802007996号 &nbsp;</span>
          <span class="gjHover" @click="toGJ">浙ICP备18057818号-2</span>
        </div>
      </div>
    </div>
    <div class="_m_footer" v-else-if="$store.state.screenWidth <= 960">
      <div class="_top">
        <div class="_left">
          <div class="_info">
            <div style="display: flex">
              <i class="iconfont icon-daohangdizhi" style="margin-right: 10px"></i>
              <div>
                <p>浙江省杭州市滨江区长河街道</p>
                <p>共鸣巷299号A楼906室</p>
              </div>
            </div>
            <p><i class="iconfont icon-24gf-telephone" style="margin-right: 10px"></i>400-0098-709</p>
            <p><i class="iconfont icon-youxiang" style="margin-right: 10px"></i>bimeng0913@163.com</p>
          </div>
        </div>
        <div class="_right">
          <div class="_wechat">
            <div class="_img"></div>
            <span>微信公众号</span>
          </div>
          <div class="_wechat">
            <div class="_img_video"></div>
            <span>微信视频号</span>
          </div>
        </div>
      </div>
      <div class="_btm">
        <p>Copyright &copy; 2015-2025</p>
        <p>杭州彼盟建筑科技管理有限公司 All Rights Reserved</p>
        <p>
          <img
            src="https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/icon_zgw.png"
            alt=""
          />浙公网安备 33010802007996号
        </p>
        <p>浙ICP备18057818号-2</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toNo1() {
      if (this.$route.name === 'About') {
        // let osTop = "100rem";
        // document.documentElement.scrollTop = document.body.scrollTop = osTop;
        this.$parent.$refs.bannerNav.toNo1()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '1'
        }
      })
    },
    toNo2() {
      // console.log(this.$parent.$refs.bannerNav)
      if (this.$route.name === 'About') {
        // var ele = document.getElementById("qywh");
        // ele.scrollIntoView({ behavior: "smooth" });
        this.$parent.$refs.bannerNav.toNo2()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '2'
        }
      })
    },
    toNo3() {
      if (this.$route.name === 'About') {
        // var ele = document.getElementById("fzlc");
        // ele.scrollIntoView({ behavior: "smooth" });
        this.$parent.$refs.bannerNav.toNo3()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '3'
        }
      })
    },
    toNo4() {
      if (this.$route.name === 'About') {
        // var ele = document.getElementById("zzjg");
        // ele.scrollIntoView({ behavior: "smooth" });
        this.$parent.$refs.bannerNav.toNo4()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '4'
        }
      })
    },
    toNo5() {
      if (this.$route.name === 'About') {
        // var ele = document.getElementById("ryzs");
        // ele.scrollIntoView({ behavior: "smooth" });
        this.$parent.$refs.bannerNav.toNo5()
        return
      }
      this.$router.push({
        name: 'About',
        params: {
          name: '5'
        }
      })
    },
    toGJ() {
      window.open('https://beian.miit.gov.cn/')
    }
  }
}
</script>

<style lang="scss" scoped>
._footer {
  width: 100%;
  height: 3.8rem;
  background-color: #050b22;

  ._center {
    height: 100%;

    ._top {
      padding-top: 0.5rem;
      display: flex;
      justify-content: space-between;

      ._left {
        width: 60%;
        display: flex;

        ._left_list {
          margin-right: 0.58rem;

          ._item {
            margin-bottom: 0.18rem;
            height: 0.2rem;
            line-height: 0.2rem;
          }

          ._title {
            margin-bottom: 0.2rem;
          }

          ._item a {
            font-size: 0.16rem;
            color: #c2c2c2;
            vertical-align: bottom;

            &:hover {
              color: #3660aa;
            }
          }

          ._title a {
            font-size: 0.18rem;
            color: #fff;
          }
        }
      }

      ._right {
        width: 60%;
        display: flex;
        justify-content: space-between;

        ._info {
          p {
            font-size: 0.16rem;
            color: #fff;
            margin-bottom: 0.35rem;
          }
        }

        ._wechat {
          color: #fff;
          text-align: center;

          ._img {
            width: 1.3rem;
            height: 1.3rem;
            background: url('https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/wechat.png') no-repeat;
            background-size: cover;
            background-position: center;
            margin-bottom: 0.16rem;
          }

          ._img_video {
            width: 1.3rem;
            height: 1.3rem;
            background: url('https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/video.png') no-repeat;
            background-size: cover;
            background-position: center;
            margin-bottom: 0.16rem;
          }

          p {
            font-size: 0.16rem;
          }
        }
      }
    }

    ._line {
      width: 100%;
      height: 0.01rem;
      background: #4d4d4d;
      margin-top: 0.05rem;
    }

    ._btm {
      margin-top: 0.3rem;
      font-size: 0.16rem;
      color: #fff;
      text-align: center;

      img {
        width: 0.2rem;
        height: 0.2rem;
        vertical-align: text-top;
      }
      .gjHover {
        cursor: pointer;
        &:hover {
          color: #ccc;
        }
      }
    }
  }
}

._m_footer {
  width: 100%;
  height: 5rem;
  background-color: #050b22;
  font-size: 0.2rem;
  color: #fff;
  padding: 0.7rem 0.72rem 0 0.85rem;

  ._top {
    display: flex;
    justify-content: space-between;

    ._left {
      width: 3.2rem;

      p {
        margin-bottom: 0.2rem;
      }
    }

    ._right {
      display: flex;
      justify-content: space-between;
      width: 2.43rem;
      display: flex;

      ._wechat {
        display: flex;
        align-items: center;
        flex-direction: column;

        ._img {
          width: 1.03rem;
          height: 1.03rem;
          background: url('https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/wechat.png') no-repeat;
          background-size: cover;
          background-position: center;
          margin-bottom: 0.16rem;
        }

        ._img_video {
          width: 1.03rem;
          height: 1.03rem;
          background: url('https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/video.png') no-repeat;
          background-size: cover;
          background-position: center;
          margin-bottom: 0.16rem;
        }
      }
    }
  }

  ._btm {
    border-top: 0.03rem solid #4d4d4d;
    text-align: center;
    padding-top: 0.55rem;

    p {
      margin-top: 0.1rem;

      img {
        vertical-align: bottom;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Footer.vue